import {
  MedScreenName,
  trackYourPrescriptionWebviewViewed,
} from "../../nativeAnalytics/medAnalytics";
import { useTrackOnceWithRetry } from "../../nativeAnalytics/hooks/useTrackOnceWithRetry";

const logPrefix = "[YourPrescriptionWebviewAnalytics]";

/**
 * Fires `your_prescription_webview_viewed` when the component that calls
 * this hook mounts. The shared `useTrackOnceWithRetry` retries on bridge
 * unavailability and guards against same-instance double fires.
 *
 * Caller contract: call from a LEAF component that only mounts once
 * user-visible content is ready (i.e. inside the success branch of
 * any loading / error ternary). Do NOT pass loading or error flags;
 * if the data isn't ready, don't render the component that calls the
 * hook. That keeps the hook generic as new queries / data sources
 * are added without changing its signature.
 */
export function useTrackYourPrescriptionWebviewViewed({
  medicationName,
}: {
  medicationName?: string;
}) {
  useTrackOnceWithRetry({
    enabled: true,
    dispatch: () => trackYourPrescriptionWebviewViewed(medicationName),
    logPrefix,
    logContext: {
      screenName: MedScreenName.YourPrescription,
      medicationName,
    },
  });
}
